import React from 'react';
import { sanitizeMarkup } from '../../util/sanitize/sanitize-html';
import { formatRateRange } from '../seeker/details/New_UI/Components/util';

const PayRateForJobDetails = ({ payRate }: any) => {
    return (
        <div>
            <div className='mb-4'>
                {payRate?.salary && (
                    <div >
                        <p className=" text-[12px] leading-[24.5px] text-[#15415E]">{(payRate?.commission || payRate?.additionalBenifits) ? `Salary + ${(payRate?.additionalBenifits === "empBO") ? "Bonus" : "Commision"}` : "Annual Salary"}</p>

                        <p className="text-instant-teams-blue-Main text-[12px]">{formatRateRange("salary", payRate?.salary, true)}</p>
                    </div>
                )}
                {payRate?.hourly && (
                    <div >
                        <p className=" text-[12px] leading-[24.5px] text-[#15415E]">{(payRate?.commission || payRate?.additionalBenifits) ? `Salary + ${(payRate?.additionalBenifits === "empBO") ? "Bonus" : "Commision"}` : "Hourly Salary"}</p>
                        <p className="text-instant-teams-blue-Main text-[12px]">{formatRateRange("hoursPerWeek", payRate?.hourly, true)}</p>
                    </div>
                )}

                {
                    !(payRate?.salary || payRate?.hourly) && payRate?.commission && <>
                        <div className=''>
                            <h1 className="text-instant-teams-blue-Main text-[14px]">
                                {(payRate?.commission || payRate?.additionalBenifits) ? payRate?.additionalBenifits === "empBO" ? "Bonus-Based" : (!payRate?.salary && !payRate?.hourly) ? "Commission-Based" : null : null}

                            </h1>

                        </div>


                    </>
                }
                {payRate?.type == "unpaid_internship" && <p className="text-sm text-instant-teams-blue-Main">Unpaid Internship</p>}
            </div>


        </div>
    );
}

export default PayRateForJobDetails;
